import { createTheme, Theme, ThemeProvider } from "@mui/material/styles";
import CircularProgress from "@mui/material/CircularProgress";
import { ComponentProps, FC } from "react";
import styled from "styled-components";
import { theme as punctTheme } from "../styles/theme";

const StyledSpinner = styled.div``;

// A nested ThemeProvider only shallow-merges a plain theme object with the
// outer one - a plain createTheme({palette: {...}}) would silently replace
// materialTheme's entire `components`/rest-of-`palette` with MUI's stock
// defaults for anything rendered inside it. Extending via a function is
// MUI's documented way to override just one value while keeping everything
// else from the outer theme.
const extendTheme = (outerTheme: Theme) =>
  createTheme(outerTheme, {
    palette: {
      primary: {
        main: punctTheme.colors.yellow,
      },
    },
  });

type Props = {
  className?: string;
  size?: number;
} & Pick<ComponentProps<typeof CircularProgress>, "color">;

const Spinner: FC<Props> = ({ className, color = "primary", size = 40 }) => {
  return (
    <StyledSpinner className={className}>
      <ThemeProvider theme={extendTheme}>
        <CircularProgress size={size} color={color} />
      </ThemeProvider>
    </StyledSpinner>
  );
};

export { Spinner };
